export const queryKeys = {
  getLookupTypes: "getLookupTypes",
  getLookupType: "getLookupType",
  getLookupTypeGrid: "getLookupTypeGrid",
};
